import { CartAddEvent } from '@theme/events';

class LmdsQuickAdd extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', this.#onSubmit);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.#onSubmit);
  }

  #onSubmit = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    event.preventDefault();
    event.stopPropagation();

    const button = form.querySelector('button[type="submit"]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    const label = button.querySelector('.lmds-quick-add__label');
    const initial = label ? label.textContent : '';
    button.setAttribute('aria-busy', 'true');

    const sectionIds = new Set();
    document.querySelectorAll('cart-items-component').forEach((element) => {
      if (element instanceof HTMLElement && element.dataset.sectionId) {
        sectionIds.add(element.dataset.sectionId);
      }
    });

    const body = new FormData(form);
    body.append('sections', Array.from(sectionIds).join(','));
    body.append('sections_url', window.location.pathname);

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || '');

      this.dispatchEvent(
        new CartAddEvent({}, String(body.get('id')), {
          source: 'product-form-component',
          itemCount: 1,
          sections: data.sections,
        })
      );

      if (label) label.textContent = button.dataset.added || initial;
      button.classList.add('is-added');
      setTimeout(() => {
        if (label) label.textContent = initial;
        button.classList.remove('is-added');
      }, 2200);
    } catch (failure) {
      if (label) label.textContent = button.dataset.error || initial;
      setTimeout(() => {
        if (label) label.textContent = initial;
      }, 2600);
    } finally {
      button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('lmds-quick-add')) {
  customElements.define('lmds-quick-add', LmdsQuickAdd);
}
